module.exports = __webpack_public_path__ + "img/googleplay.d41fe1f3.png";